import { Button, Typography } from '@material-ui/core'
import React from 'react'
import currentDate from './currentDate'
import {
  Datalist,
  Input,
  Label,
  Optionlist,
  Select,
  FileInput,
  FileContainer,
  FileName,
  Wrapper,
  ErrorMessage
} from './styles'
import {
  AUTOCOMPLETE_TYPE,
  DATETIME_PICKER_TYPE,
  FILE_INPUT_TYPE,
  INPUT_TYPE,
  SELECT_TYPE,
  W_TAX_CODE_FIELD
} from './types'
const fields = {
  [AUTOCOMPLETE_TYPE]: props => {
    return (
      <Wrapper>
        <Label>{props.label}</Label>
        <Input
          {...props}
          list={`${props.fieldName}ListOptions`}
          autoComplete={false}
          error={props.error}
        />
        <Datalist id={`${props.fieldName}ListOptions`}>
          {props.options.map((data, index) => (
            <Optionlist key={index} value={data} />
          ))}
        </Datalist>
        <ErrorMessage error={props.error}>{props.errorMessage}</ErrorMessage>
      </Wrapper>
    )
  },
  [SELECT_TYPE]: props => {
    return (
      <Wrapper>
        <Label>{props.label}</Label>
        <Select {...props} error={props.error} placeholder={props.placeholder}>
          <option value='' disabled selected>
            Required
          </option>
          {props.options.map((data, index) => (
            <option key={index} value={data}>
              {data}
            </option>
          ))}
        </Select>
        <div />
        <ErrorMessage error={props.error}>{props.errorMessage}</ErrorMessage>
      </Wrapper>
    )
  },
  [INPUT_TYPE]: props => {
    return (
      <Wrapper>
        <Label>{props.label}</Label>
        <Input {...props} error={props.error} />
        <ErrorMessage error={props.error}>{props.errorMessage}</ErrorMessage>
      </Wrapper>
    )
  },
  [DATETIME_PICKER_TYPE]: props => {
    return (
      <Wrapper>
        <Label>{props.label}</Label>
        <Input
          {...props}
          type='date'
          min={currentDate()}
          error={props.error}
          onKeyDown={e => {
            e.preventDefault()
          }}
        />
        <ErrorMessage error={props.error}>{props.errorMessage}</ErrorMessage>
      </Wrapper>
    )
  },
  [FILE_INPUT_TYPE]: props => {
    return (
      <Wrapper>
        <Label>{props.label}</Label>
        <FileContainer error={props.error}>
          <FileName>{props?.value?.name}</FileName>
          <FileInput>
            <Button>Upload a file</Button>
            <input type='file' onChange={props.onChange} accept='.pdf' />
          </FileInput>
          <ErrorMessage error={props.error}>{props.errorMessage}</ErrorMessage>
        </FileContainer>
      </Wrapper>
    )
  },
  [W_TAX_CODE_FIELD]: props => {
    return (
      <Wrapper>
        <Label>{props.label}</Label>
        <Input {...props} error={props.error} />
        <ErrorMessage error={props.error}>{props.errorMessage}</ErrorMessage>
      </Wrapper>
    )
  }
}
export default fields
